import { createRouter as _createRouter, createWebHashHistory } from 'vue-router'

import Index from './views/Index.vue'

const ExternalServices = () => import('./views/ExternalServices.vue')
const Team = () => import('./views/Team.vue')
const Clients = () => import('./views/Clients.vue')
const Client = () => import('./views/Client.vue')
const Staffing = () => import('./views/Staffing.vue')
const UserProfile = () => import('./views/UserProfile.vue')
const Sponsorships = () => import('./views/Sponsorships.vue')
const Managers = () => import('./views/Managers.vue')
const Documents = () => import('./views/Documents.vue')
const SponsorshipForm = () => import('./views/SponsorshipForm.vue')
const SponsorForm = () => import('./views/SponsorForm.vue')
const Availability = () => import('./views/Availability.vue')
const NotFound = () => import('./views/404.vue')

const createRouter = () => {
  const routes = [
    {
      path: '/',
      component: Index,
      redirect: '/availability',
      children: [
        { path: '/availability', component: Availability },
        { path: '/external-services', component: ExternalServices },
        { path: '/team', component: Team },
        {
          path: '/team/:userId',
          component: UserProfile,
          props: (route) => ({ userId: parseInt(route.params.userId, 10) }),
        },
        { path: '/clients', component: Clients },
        {
          path: '/clients/:clientId',
          component: Client,
          props: (route) => ({ clientId: parseInt(route.params.clientId, 10) }),
        },
        { path: '/staffing', component: Staffing },
        { path: '/sponsorships', component: Sponsorships },
        { path: '/managers', component: Managers },
        { path: '/documents', component: Documents },
        { path: '/sponsorships/new', component: SponsorshipForm },
        {
          path: '/sponsorships/:sponsorshipId',
          component: SponsorshipForm,
          props: (route) => ({ sponsorshipId: parseInt(route.params.sponsorshipId, 10) }),
        },
        { path: '/sponsorships/sponsors/new', component: SponsorForm },
        {
          path: '/sponsorships/sponsors/:sponsorId',
          component: SponsorForm,
          props: (route) => ({ sponsorId: parseInt(route.params.sponsorId, 10) }),
        },
        {
          path: '/404',
          name: 'NotFound',
          component: NotFound,
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/404' },
  ]

  const router = _createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes,
  })

  return router
}

export default createRouter
